import { cn } from "@/lib/utils";

const ChatMessage = ({ message, index }) => {
    const isUser = message.role === "user";
    const isSystem = message.system;
    return (
        <div
            className={cn(
                "flex w-full",
                isUser ? "justify-end" : "justify-start",
            )}
            data-testid={`chat-message-${message.role}-${index}`}
        >
            <div
                className={cn(
                    "max-w-[85%] px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap break-words",
                    isUser
                        ? "bg-brand-coral text-white"
                        : isSystem
                          ? "bg-brand-offwhite text-brand-dark border-l-4 border-brand-coral"
                          : "bg-brand-offwhite text-brand-dark border-l-4 border-brand-cyan",
                )}
            >
                {message.content}
            </div>
        </div>
    );
};

export default ChatMessage;
